<div class="h-full">
    <app-ongletlayout
        storageId="parametres-marches"
        [ongletLinks]="tableLinkForMarche"
    >
        <div class="border">
            <router-outlet></router-outlet>
        </div>
    </app-ongletlayout>
</div>